module.exports = __webpack_public_path__ + "static/media/don-0.17fa5da8.png";